export const isObjectEmpty = (objectName) => {
    return objectName && Object.keys(objectName).length === 0 && objectName.constructor === Object;
};
export const groupBy = (array, predicate) => array.reduce((acc, value, index, array) => {
    var _a;
    (acc[_a = predicate(value, index, array)] || (acc[_a] = [])).push(value);
    return acc;
}, {});
